<template>
  <input
    class="form-control"
    type="text"
    :value="displayValue"
    @keydown="onKeyDown"
    @focus="onFocus"
    @blur="onBlur"
  />
</template>

<script>
export default {
  name: "DecimalInputMasked",
  props: {
    value: {
      type: String,
      default: "0,00",
    },
  },
  data() {
    return {
      amount: 0, // Valor em centavos
    };
  },
  computed: {
    displayValue() {
      // Formata o valor para o padrão brasileiro, ex: 1.000,00
      const val = (this.amount / 100).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return val;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        // Analisa a string formatada e atualiza o amount
        this.amount = this.parseFormattedString(newVal);
      },
    },
  },
  methods: {
    onKeyDown(event) {
      const key = event.key;

      // Permitir teclas de navegação
      if (["ArrowLeft", "ArrowRight", "Tab"].includes(key)) {
        return;
      }

      // Prevenir a ação padrão
      event.preventDefault();

      if (/^\d$/.test(key)) {
        // Desloca os dígitos existentes para a esquerda e adiciona o novo dígito
        this.amount = this.amount * 10 + parseInt(key);

        // Emite a string formatada atualizada para o componente pai
        this.$emit("input", this.displayValue);
      } else if (key === "Backspace" || key === "Delete") {
        // Remove o dígito mais à direita
        this.amount = Math.floor(this.amount / 10);

        // Emite a string formatada atualizada para o componente pai
        this.$emit("input", this.displayValue);
      }
    },
    onFocus(event) {
      // Seleciona todo o texto ao focar
      event.target.select();
    },
    onBlur() {
      // Garantir que o valor não seja negativo ao perder o foco
      if (this.amount < 0) {
        this.amount = 0;
      }
    },
    parseFormattedString(value) {
      if (!value) return 0;
      // Remove pontos e substitui a vírgula por ponto para converter em número
      const normalized = value.replace(/\./g, "").replace(",", ".");
      const parsed = parseFloat(normalized);
      if (isNaN(parsed)) {
        return 0;
      }
      // Converte para centavos
      return Math.round(parsed * 100);
    },
  },
  created() {
    // Inicializa o amount com base no valor formatado recebido
    this.amount = this.parseFormattedString(this.value);
  },
};
</script>
